



























































































































































































































































































































































































































































































import { VSelect } from 'vuetify/lib';
import AMSTable from '@/components/AMSTable.vue';
import request from '@/utils/request';
import AMSProductImg from '@/components/AMSProductImg.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { stock, shippedList } from '@/api/order';
import { shipMergeBySf, shipSettlementStatus, putShip, logistics, cancelShip, getShipStatusName, shipBySf, shipCompany, cancel, ship, getShipCompanyName } from '@/api/shipment';
import utils from '@/utils/utils';
import AMSImg from '@/components/AMSImg.vue';
import { AppStore } from '@/store/modules/app';
import { UserStore } from '@/store/modules/user';
import { emptyRule, rangeLengthRule } from '@/utils/rules';
import AMSDialog from '@/components/AMSDialog.vue';
import { setPrintData } from '@/utils/auth';
import moment from 'moment';
import Logistics from '@/views/orderManage/shipmentsManagement/logisticsManageList.vue';
import ShipInfoManagerList from '@/views/orderManage/shipmentsManagement/shipInfoMangeList.vue';
import { confirmReceiveShipment, confirmCancelGiveOut } from '@/api/materials';

@Component({
  components: {
    'ams-table': AMSTable,
    'ams-dialog': AMSDialog,
    'ams-img': AMSImg,
    'logistics-manage-list': Logistics,
    'ship-info-manager-list': ShipInfoManagerList
  }
})
export default class ShipCharge extends Vue {
  // 顺丰寄件弹窗form
  shipBysFValid: boolean = true;
  quantityRules = [
    (value: any) => !!value || '件数不能为空',
    (value: any) => (value && value !== '0') || '件数不能为0',
    (value: any) => (value && Number(value) <= 50) || '件数不能超过50个'
  ];
  /**发货信息管理弹窗 */
  showManagerShipInfoDialog: boolean = false;
  showConfirmDeleteLastShipDialog: boolean = false;
  /**自行发货 */
  selfLogistics: any[] = [];
  /**顺丰发货 */
  sfLogistics: any[] = [];
  /**是否是继续发货 */
  isContinuteShip: boolean = false;

  /**顺丰寄件弹窗 */
  showShunfengShipDialog: boolean = false;
  showZhongTongShipDialog: boolean = false;
  /**顺丰寄件结算方式 */
  shipSettlementStatusItems: any[] = [...shipSettlementStatus];
  parcelQuantity = '1'; //寄件件数
  /**当前选择的结算方式 默认是到付现结*/
  shipSettlementStatus: string = 'DeliverFeeToBeCollected';
  shufengLoading: boolean = false;
  zhongTongLoading: boolean = false;
  modalTypeAll: boolean = false; //true->一键全部配货，false->配货并出库
  /**物流管理信息 */
  logistics: any[] = [
    {
      company: '',
      number: ''
    }
  ];
  @Prop({
    default: () => {
      return {};
    }
  })
  materialsInfo!: any;
  @Prop({
    default: () => {
      return [];
    }
  })
  ships!: any; /**发货清单 */
  @Prop({
    default: () => {
      return [];
    }
  })
  allocation!: any; /**配货清单 */
  @Prop({
    default: () => {
      return {};
    }
  })
  deliverys!: any; /**出库清单 */
  requestLoading: Boolean = false;
  // 配货headers
  headers: any = {
    pendingAllocationHeaders: [
      { text: '序号', align: 'center', sortable: false, width: '50px', isSort: true },
      {
        text: '商品',
        align: 'left',
        sortable: false,
        value: 'product',
        width: 300,
        render: (h: any, param: any) => {
          return h(AMSProductImg, {
            props: {
              product: param.row[param.keyName],
              pictureWidth: 40,
              pictureHeight: 40,
              isShowNumber: true
            }
          });
        }
      },
      { text: '申请数', align: 'right', sortable: false, value: 'orderQuantity' },
      { text: '已配货数', align: 'right', sortable: false, value: 'allocationQuantity' },
      { text: '待配货数', align: 'right', sortable: false, value: 'pendingAllocationQuantity' },
      { text: '实际库存', align: 'right', sortable: false, value: 'stockQuantity' },
      { text: '配货数量', align: 'left', sortable: false, value: 'quantity', isInputNumber: { type: 'quantity' } },
      {
        text: '限用日期',
        width: '400px',
        value: 'productionDate',
        align: 'left',
        sortable: false,
        render: (h: any, param: any) => {
          return h(VSelect, {
            on: {
              change: (e: any) => {
                param.row[param.keyName] = e;
              }
            },
            props: {
              clearable: true,
              width: '150px',
              items: param.row.stockProducts.map((item: any) => {
                return {
                  text: moment(item.productionDate).format('YYYY-MM-DD') + ` （库存数：${item.quantity}）`,
                  value: moment(item.productionDate).format('YYYY-MM-DD')
                };
              })
            }
          });
        }
      }
    ],
    noActionpendingAllocationHeaders: [
      { text: '序号', align: 'center', sortable: false, width: '50px', isSort: true },
      {
        text: '商品',
        align: 'left',
        sortable: false,
        value: 'product',
        width: 300,
        render: (h: any, param: any) => {
          return h(AMSProductImg, {
            props: {
              product: param.row[param.keyName],
              pictureWidth: 40,
              pictureHeight: 40,
              isShowNumber: true
            }
          });
        }
      },
      { text: '申请数', align: 'center', sortable: false, value: 'orderQuantity' },
      { text: '已配货数', align: 'center', sortable: false, value: 'allocationQuantity' },
      { text: '待配货数', align: 'center', sortable: false, value: 'pendingAllocationQuantity' },
      { text: '实际库存', align: 'center', sortable: false, value: 'stockQuantity' },
      { text: '配货数量', align: 'center', sortable: false, value: 'quantity' }
    ],
    pickShow: true,
    deliveryHeaders: [
      {
        text: '序号',
        align: 'center',
        sortable: false,
        isSort: true,
        width: 50
      },
      {
        text: '商品',
        align: 'left',
        sortable: false,
        value: 'product',
        width: 300,
        render: (h: any, param: any) => {
          return h(AMSProductImg, {
            props: {
              product: param.row[param.keyName],
              pictureWidth: 40,
              pictureHeight: 40,
              isShowNumber: true
            }
          });
        }
      },
      {
        text: '容量',
        align: 'right',
        sortable: false,
        value: 'capacity',
        render: (h: any, param: any) => {
          return h('div', param.row.product.capacity);
        }
      },
      { text: '出库数', align: 'right', sortable: false, value: 'stockQuantity' }
    ],
    deliveryShow: true,
    shipHeaders: [
      { text: '序号', align: 'center', sortable: false, width: 50, isSort: true },
      {
        text: '商品',
        align: 'left',
        sortable: false,
        width: '300px',
        value: 'product',
        render: (h: any, param: any) => {
          return h(AMSProductImg, {
            props: {
              product: param.row[param.keyName],
              pictureWidth: 40,
              pictureHeight: 40,
              isShowNumber: true
            }
          });
        }
      },
      {
        text: '容量',
        align: 'right',
        sortable: false,
        value: 'capacity',
        render: (h: any, param: any) => {
          return h('div', param.row.product.capacity);
        }
      },
      { text: '发货数', align: 'right', sortable: false, value: 'stockQuantity' }
    ],
    shipShow: true
  };
  showIcon: string = 'unfold_less';
  hideIcon: string = 'unfold_more';
  /**打印出库单的数据 */
  printData: any = {
    totalCount: 0,
    items: [],
    headers: [
      { text: '序号', align: 'center', sortable: false },
      { text: '商品', align: 'center', sortable: false },
      { text: '容量', align: 'center', sortable: false },
      { text: '数量', align: 'center', sortable: false }
    ],
    stockNumber: ''
  };
  /**寄件件数输入事件 */
  changeParcelQuantity(v: any) {
    if (v) {
      // 只能输入数字
      let t = v.replace(/\D/g, '');
      this.$nextTick(() => {
        this.parcelQuantity = t;
      });
    }
  }
  logNumber = 50; //物流个数限制
  /**打印弹窗 */
  printDialog: boolean = false;
  shipActionItems: any[] = ['输入发货信息', '顺丰寄件'];
  /**当前操作的item */
  currentItem: any = null;
  /**直接发货 弹窗 */
  showInfoDialog: boolean = false;
  /**直接发货de时间选择器 */
  menu: boolean = false;
  /**当前时间 */
  currentTime: string = new Date().toISOString().substr(0, 10);
  /**物流公司 */
  shipItems: any[] = [...shipCompany];
  /**直接发货de时间 */
  date: string = new Date().toISOString().substr(0, 10);
  /**直接发货de物流公司 */
  ship: any = { key: '' };
  /**直接发货de物流单号 */
  shipNumber: string = '';
  /**物流信息 */
  shipDatas: any = {};
  /**物流信息弹窗 */
  logisticsDialog: boolean = false;
  allocationDialog: boolean = false; //配货弹窗
  allocationRemark: string = '';
  valid: boolean = true;
  nameRules: Array<any> = [emptyRule('备注')];
  /**当前是管理物流单号还是新增 */
  isManagerLogistcs: boolean = false;
  /*确认发放*/
  okGrant(item: any, index: any) {
    confirmReceiveShipment(item.id).then(() => {
      AppStore.ShowSuccess('操作成功！');
      this.refresh();
    });
  }

  /*取消发放*/
  cancelGrant(item: any, index: any) {
    confirmCancelGiveOut(item.id).then(() => {
      AppStore.ShowSuccess('取消成功！');
      this.refresh();
    });
  }
  /*发放*/
  grant(item: any, index: any) {
    let param = {
      shipmentIds: [item.id]
    };
    const _this = this;
    ship(param)
      .then(response => {
        AppStore.ShowSuccess('发放成功');
        _this.refresh();
      })
      .catch(error => {});
  }
  /**发货管理 确定删除最后一条发货 点击取消*/
  closeConfirmDeleteLastShipDialog() {
    this.showConfirmDeleteLastShipDialog = false;
  }

  /**发货管理  确定删除最后一条发货 点击确定*/
  submitConfirmDeleteLastShipDialog() {
    this.showConfirmDeleteLastShipDialog = false;
    this.showManagerShipInfoDialog = false;
    this.onShipCancelClick(this.currentItem, -1);
  }
  /**发货管理 发货信息准备删除最后一条的时候，调用取消发货接口 */
  handleCancleShip() {
    this.showConfirmDeleteLastShipDialog = true;
  }
  /**发货信息管理点击取消 */
  closeMangerShipInfoAMSDialog() {
    this.reset();
    this.refresh();
    this.showManagerShipInfoDialog = false;
  }
  /**发货信息管理点击保存 */
  submitMangerShipInfoAMSDialog() {
    if (this.selfLogistics.length <= 0) {
      this.refresh();
      this.showManagerShipInfoDialog = false;
    } else {
      this.selfLogistics.forEach(item => {
        if (item.items) {
          item.items.forEach((el: any) => {
            if (el.company === 'SelfMention') delete el.number;
          });
        }
      });
      let param = { selfLogistics: this.selfLogistics };
      putShip(param)
        .then(response => {
          AppStore.ShowSuccess('修改发货信息成功');
          this.refresh();
          this.showManagerShipInfoDialog = false;
        })
        .catch(error => {});
    }
  }

  /**顺丰寄件弹窗点击关闭 */
  closeShunfengShipAMSDialog() {
    this.reset();
    this.showShunfengShipDialog = false;
  }

  /**顺丰寄件弹窗点击保存 */
  submitShunfengShipAMSDialog() {
    if (!(this.$refs.shipBysF as any).validate()) {
      return;
    }
    let param = {};
    let mes = '';
    if (this.currentItem) {
      param = {
        shipmentIds: [this.currentItem.id],
        sfPayMethod: this.shipSettlementStatus,
        parcelQuantity: Number(this.parcelQuantity),
        isSF: true
      };
      mes = '发起顺丰寄件成功';
    }
    const _this = this;
    this.shufengLoading = true;
    AppStore.ShowWarning('生成面单中，请耐心等待', 10000);
    shipMergeBySf(param)
      .then((response: any) => {
        this.shufengLoading = false;
        AppStore.ShowSuccess(mes);
        this.showShunfengShipDialog = false;
        this.reset();
        this.refresh();
        let routeData = _this.$router.resolve({
          name: 'shufengPrint',
          query: { key: `${response}` }
        });
        window.open(routeData.href, '_blank');
      })
      .catch(error => {
        this.shufengLoading = false;
      });
  }

  /**中通寄件弹窗点击保存 */
  submitZhongTongShipAMSDialog() {
    if (!(this.$refs.shipBysF as any).validate()) {
      return;
    }
    let param = {};
    let mes = '';
    if (this.currentItem) {
      param = {
        shipmentIds: [this.currentItem.id],
        parcelQuantity: Number(this.parcelQuantity)
      };
      mes = '发起中通寄件成功';
    }
    const _this = this;
    this.shufengLoading = true;
    AppStore.ShowWarning('生成订单中，请耐心等待', 1000);
    shipMergeBySf(param)
      .then((response: any) => {
        this.zhongTongLoading = false;
        AppStore.ShowSuccess(mes);
        this.showZhongTongShipDialog = false;
        this.reset();
        this.refresh();
        let routeData = _this.$router.resolve({
          name: 'zhongtongPrint',
          query: { key: `${response}` }
        });
        window.open(routeData.href, '_blank');
      })
      .catch(error => {
        this.zhongTongLoading = false;
      });
  }

  getLogisticsCompanyName(name: any) {
    return getShipCompanyName(name);
  }

  /**点击了弹窗取消按钮 */
  closeAMSDialog() {
    this.showInfoDialog = false;
    this.logistics = [
      {
        company: '',
        number: ''
      }
    ];
    this.reset();
  }

  reset() {
    this.currentItem = null;
    (this.$refs.shipForm as any).resetValidation();
    this.ship = { key: '' };
    this.shipNumber = '';
    this.date = new Date().toISOString().substr(0, 10);
    this.logistics = [
      {
        company: '',
        number: ''
      }
    ];
  }

  /**发货信息管理点击 */
  onManagerLogistcsClick(item: any, index: any) {
    var sl = JSON.stringify(item.selfLogistics || []);
    var n_sl = JSON.parse(sl);
    n_sl.map((v: any) => {
      v.shippedTime = this.formatDateTimeMM(v.shippedTime);
    });
    this.selfLogistics = n_sl;
    var sf = JSON.stringify(item.sfLogistics || []);
    this.sfLogistics = JSON.parse(sf);
    this.currentItem = item;
    this.showManagerShipInfoDialog = true;
  }

  formatDateTimeMM(date: any) {
    return moment(date).format('YYYY-MM-DD');
  }

  /**点击了弹窗确定按钮 */
  submitAMSDialog() {
    let prama = {};
    this.logistics.forEach(item => {
      if (item.company === 'SelfMention') delete item.number;
    });
    prama = {
      shipmentIds: [this.currentItem.id],
      shipTime: moment(this.date).toISOString(),
      logistics: this.logistics
    };
    const _this = this;
    if ((this.$refs.shipForm as any).validate()) {
      ship(prama)
        .then(response => {
          AppStore.ShowSuccess('发货成功');
          _this.showInfoDialog = false;
          _this.reset();
          _this.refresh();
        })
        .catch(error => {
          _this.showInfoDialog = false;
          _this.reset();
        });
    }
  }

  @Watch('materialsInfo', { immediate: true, deep: true })
  onOrderInfoChange(value: any, oldValue: any) {
    if (value) {
      this.materialsInfo = value;
    }
  }
  getPermission(name: string) {
    return utils.isPermission(name);
  }
  getTotalCount(item: any) {
    let count = 0;
    if (item) {
      item.map((v: any) => {
        if (!isNaN(parseInt(v.stockQuantity))) {
          count += parseInt(v.stockQuantity);
        }
      });
      return count;
    }
  }
  /**物流信息弹窗 标题 */
  get logisticeListName() {
    return this.shipDatas && this.shipDatas.logisticsNumber ? `${getShipCompanyName(this.shipDatas.company)}:${this.shipDatas.logisticsNumber}` : '';
  }

  /**快递单号rule */
  get shipNumberRules() {
    let rules: any[] = [];
    if (this.shipNumber) {
      if (this.shipNumber.length < 5) {
        return ['请填写5-25位的物流单号'];
      }
      return [...rules, rangeLengthRule(5, 25, '快递单号')];
    }
  }
  /**点击了打印关闭弹窗 */
  onCloseClick() {
    this.printDialog = false;
  }
  /**点击了弹窗里面的打印 */
  onConfimPrintClick() {
    // console.log((this.$refs.printDiv as Element).innerHTML);
    let content: string = this.generateHtml();
    let iframe = document.createElement('iframe');
    iframe.id = 'printIframe';
    // iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
    let f = document.body.appendChild(iframe);
    let w = (f.contentWindow || f.contentDocument) as Window;
    let doc = f.contentDocument || f.contentWindow!.document;
    doc.open();
    doc.write(content);
    doc.close();
    iframe.onload = function() {
      w.focus();
      try {
        if (!w.document.execCommand('print', false)) {
          w.print();
        }
      } catch (e) {
        w.print();
      }
      w.close();
      document.body.removeChild(iframe);
    };
  }
  generateHtml(): string {
    let style = this.getStyle();
    let content: string = (this.$refs.printDiv as Element).innerHTML;
    let html = `<head>${style}</head><body>${content}</body>`;
    return html;
  }
  getStyle(): string {
    var str = '',
      styles = document.querySelectorAll('style,link');
    for (var i = 0; i < styles.length; i++) {
      str += styles[i].outerHTML;
    }
    return str;
  }

  /********* 配送出库*/
  get totalAllocation(): number {
    return this.allocation.length;
  }
  get totalPendingAllocationQuantity(): number {
    return this.allocation
      .map((item: any) => {
        return parseInt(item.pendingAllocationQuantity);
      })
      .reduce((a: number, b: number) => {
        return a + b;
      }, 0);
  }
  totalQuantity(): number {
    return this.allocation
      .filter((item: any) => {
        return item.quantity;
      })
      .map((i: any) => {
        return parseInt(i.quantity);
      })
      .reduce((a: number, b: number) => {
        return a + b;
      }, 0);
  }
  get cantAllocation(): boolean {
    let disable = false;
    this.allocation.forEach((allocation: any) => {
      if (parseInt(allocation.quantity) > Math.min(parseInt(allocation.stockQuantity < 0 ? 0 : allocation.stockQuantity), parseInt(allocation.pendingAllocationQuantity))) {
        disable = true;
      }
    });
    let hasQuantity = this.allocation.filter((f: any) => {
      return f.quantity && parseInt(f.quantity) !== 0;
    });
    if (!hasQuantity.length) {
      disable = true;
    }
    return disable;
  }
  // 一键全部配货
  confirmAllOrder() {
    (this.$refs.form as any) && (this.$refs.form as any).resetValidation();
    this.allocationDialog = true;
    this.modalTypeAll = true;
    this.allocationRemark = '';
  }
  //打开配货并出库的弹窗
  confirmAllocationOrder() {
    (this.$refs.form as any) && (this.$refs.form as any).resetValidation();
    this.allocationDialog = true;
    this.modalTypeAll = false;
    this.allocationRemark = '';
  }
  //取消配货并出库的弹窗
  cancelAllocation() {
    this.allocationDialog = false;
  }
  //确认配货并出库的弹窗
  sureAllocation(stop: Function) {
    if ((this.$refs.form as any).validate()) {
      this.requestLoading = true;
      if (this.modalTypeAll) {
        this.allocationOrderAll(stop);
      } else {
        this.allocationOrder(stop);
      }
    } else {
      stop();
    }
  }
  // 确定一键全部配货
  allocationOrderAll(stop: Function) {
    let formData = {
      orderId: this.$route.query.id,
      remark: this.allocationRemark
    };
    request
      .post('/api/Shipment/AutoShipment', formData)
      .then((data: any) => {
        this.allocationDialog = false;
        this.refresh();
        AppStore.ShowSuccess('操作成功！');
      })
      .finally(() => {
        this.requestLoading = false;
        stop();
      })
      .catch((err: any) => {
        this.requestLoading = false;
        stop();
      });
  }
  // 确定指定配货
  allocationOrder(stop: Function) {
    let formData = {
      orderId: this.$route.query.id,
      remark: this.allocationRemark,
      items: this.allocation
        .map((pending: any) => {
          if (pending.quantity && parseInt(pending.quantity) !== 0) {
            return {
              productId: pending.id,
              quantity: parseInt(pending.quantity),
              productionDate: pending.productionDate ? moment(pending.productionDate).format('YYYY-MM-DD') : null
            };
          }
        })
        .filter((f: any) => {
          return f;
        })
    };
    request
      .post('/api/Shipment/Allocation', formData)
      .then((data: any) => {
        this.allocationDialog = false;
        this.refresh();
        AppStore.ShowSuccess('操作成功！');
      })
      .finally(() => {
        this.requestLoading = false;
        stop();
      })
      .catch((err: any) => {
        this.requestLoading = false;
        stop();
      });
  }

  /**直接发货选择了物流公司 */
  onShipClick(item: any, index: number) {
    this.ship = item;
  }

  /**点击了出库清单的发货 */
  onShipTypeClick(type: string, item: any) {
    switch (type) {
      case '输入发货信息':
        this.isManagerLogistcs = false;
        this.currentItem = item;
        this.showInfoDialog = true;
        this.logNumber = item.logistics ? 50 - item.logistics.length : 50;
        break;
      case '顺丰寄件':
        (this.$refs.shipBysF as any).resetValidation();
        if (!item || !item.id) return;
        this.currentItem = item;
        this.parcelQuantity = '1';
        this.showShunfengShipDialog = true;
        break;
      case '中通寄件':
        (this.$refs.shipByZT as any).resetValidation();
        if (!item || !item.id) return;
        this.currentItem = item;
        this.parcelQuantity = '1';
        this.showZhongTongShipDialog = true;
        break;
      default:
        break;
    }
  }

  /**点击了出库清单的取消出库 */
  onStockCancelClick(item: any, index: number) {
    const _this = this;
    cancel(item.id)
      .then(response => {
        AppStore.ShowSuccess('取消出库成功');
        _this.$emit('refreshShip');
        _this.$emit('refreshDetail');
      })
      .catch(error => {});
  }

  /**点击了取消发货 */
  onShipCancelClick(item: any, index: number) {
    const _this = this;
    cancelShip(item.id)
      .then(response => {
        AppStore.ShowSuccess('取消发货成功');
        _this.$emit('refreshShip');
        _this.$emit('refreshDetail');
      })
      .catch(error => {});
  }

  /**点击了发货清单的打印按钮 */
  onPrintClick(item: any, index: number) {
    let routeData = this.$router.resolve({
      name: 'shipmentPrint',
      query: { id: item.id }
    });
    window.open(routeData.href, '_blank');
  }

  /**点击了出库清单的打印出库单 */
  onStockPrintClick(item: any, index: number) {
    let routeData = this.$router.resolve({
      name: 'shipmentPrint',
      query: { id: item.id }
    });
    window.open(routeData.href, '_blank');
  }

  /**点击了复制按钮 */
  onCopyClick(name: string) {
    const ele = document.getElementById(name);
    if (ele) {
      const num = ele.innerText;
      var oInput = document.createElement('input');
      oInput.value = num;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      AppStore.ShowSuccess('已复制到粘贴板');
    }
  }

  /**物流单号输入事件 */
  onLogisticNumber(v: any) {
    if (v) {
      // 只能输入数字
      // let t = v.replace(/\D/g, '');
      //只能输入数字和英文
      let t = v.replace(/[\W]/g, '');
      this.$nextTick(() => {
        this.shipNumber = t;
      });
    }
  }

  refresh() {
    this.$emit('refreshShip');
    this.$emit('refreshDetail');
  }

  /**点击了查看物流 */
  onViewLogisticsClick(item: any) {
    if (item.logisticsNumber && item.logisticsCompany) {
      logistics(item.id)
        .then(response => {
          this.shipDatas = response;
          if (this.shipDatas.datas) {
            this.shipDatas.datas.map((v: any) => {
              const date = utils.formatDateByFormat(v.trackTime, 'yyyy-MM-dd hh:mm:ss');
              v.trackTime = date;
            });
          }
          this.logisticsDialog = true;
        })
        .catch(error => {});
    } else {
      return false;
    }
  }
}
